import { render } from "./CreateDemo.vue?vue&type=template&id=29cab086"
import script from "./CreateDemo.vue?vue&type=script&lang=js"
export * from "./CreateDemo.vue?vue&type=script&lang=js"

import "./CreateDemo.vue?vue&type=style&index=0&id=29cab086&lang=css"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__